import axios from 'axios';
import Vue from 'vue'

import store from '../store';

// Utilizzo gli interceptors di Axios per mostrare il messaggio di errore ogni volta
axios.interceptors.response.use(
	response => { // Risposta positiva, semplicemente la restituisco
	  return response;
	},
	error => {
		// Se l'errore è 500 allora mostro un errore generico, altrimenti mostro il messaggio associato

		console.log(error)
		if (error.response.status == 500) {
			store.commit('mostraSnack', {messaggio: 'Si è verificato un errore', tipo: 'error'})
		} else {
			if(error.response) // Se la risposta è arrivata correttamente
				store.commit('mostraSnack', {messaggio: error.response.data.message, tipo: 'error'})
			else // Altrimenti stampo un messaggio di errore generico
				store.commit('mostraSnack', {messaggio: 'Si è verificato un errore', tipo: 'error'})
		}

		// Altri status code dovranno essere trattati nelle singole richieste
  
	  	return Promise.reject(error); // Restituisco una promessa rigettata per propagare l'errore
	}
  );

import VueRouter from 'vue-router';
import routes from './routes';

Vue.use(VueRouter);

const router = new VueRouter({
	// mode: 'history',
	// base: '/',
	routes,
});

router.afterEach((to, from) => {
	if (window.dataLayer) {
	  window.dataLayer.push({
		event: 'pageview',
		page: {
		  path: to.fullPath, // Percorso della nuova pagina
		  title: document.title, // Titolo della pagina (aggiorna dinamicamente il titolo se necessario)
		  location: window.location.href, // URL completo della pagina
		},
	  });
	} else {
	  console.warn('dataLayer non trovato. Assicurati che il codice GTM sia correttamente installato.');
	}
});

// router.beforeEach((to, from, next) => {
//   axios.get('/is_logged')
// 	.then(res => {
// 		store.commit('setIsLogged', res.data);
// 		if (to.name !== 'tecnici' && !store.state.isLogged) next({ name: 'tecnici'})
// 		else next()
// 	})
// })

export default router;